module.exports = __webpack_public_path__ + "assets/img/authority-1.64ddf8cb.svg";